import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { Adresse } from 'src/app/utils/interfaces/new/adresse.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-histo-contact',
  templateUrl: './histo-contact.fragment.html',
  styleUrls: [
    './histo-contact.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class HistoContactFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeHistoContactModal(false);
    }
  }

  @Output() public closeEmitter = new EventEmitter();

  public idPatient: string;
  public isEdit = false;
  public listContact: Paginated<Adresse>;
  public contactColumnTable = [
    { title: 'Adresse', data: 'adresse', isEditable: true, editType: 'string' },
    { title: 'Complément adresse', data: 'complementAdresse', isEditable: true, editType: 'string' },
    { title: 'Code postal', data: 'codePostal', isEditable: true, editType: 'string' },
    { title: 'Ville', data: 'ville', isEditable: true, editType: 'string' },
    { title: 'Téléphone', data: 'telephone', isEditable: true, editType: 'string', validators: [this.checkPhoneNumber], errorMessage: 'Le numéro saisi est incorrecte' },
    { title: 'Email', data: 'email', isEditable: true, editType: 'string', validators: [Validators.email, Validators.pattern(/[aA-zZ]+[.][aA-zZ]{2,}/)], errorMessage: 'Le mail saisi est incorrecte' },
    { title: 'Adresse principale', data: 'isPrincipale', isEditable: true, editType: 'boolean' },
    { title: 'Supprimer', data: null }
  ];
  public deletedAdresses: Adresse[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.listContact) {
      for (let contact of this.listContact.objects) {
        if (contact.disabled) {
          this.deletedAdresses.push(contact);
        }
      }
      for (let delContact of this.deletedAdresses) {
        const deleteIndex = this.listContact.objects.findIndex(x => x.id === delContact.id);
        if (deleteIndex > -1) {
          this.listContact.objects.splice(deleteIndex, 1);
        }
      }
    }
  }

  deleteContact(event: any) {
    const deleteContactIndex = this.listContact.objects.findIndex(x => x.id === event.id);
    if (deleteContactIndex > -1) {
      this.listContact.objects[deleteContactIndex].disabled = true;
      this.deletedAdresses.push(this.listContact.objects[deleteContactIndex]);
      this.listContact.objects.splice(deleteContactIndex, 1);
    }
  }

  changeContacts(event: any) {
    for (let contact of event) {
      const index = this.listContact.objects.findIndex(x => x.id === contact.id)
      if (index > -1) {
        this.listContact.objects[index] = {
          adresse: contact.adresse ? contact.adresse : undefined,
          complementAdresse: contact.complementAdresse ? contact.complementAdresse : undefined,
          codePostal: contact.codePostal ? contact.codePostal : undefined,
          ville: contact.ville ? contact.ville : undefined,
          email: contact.email ? contact.email : undefined,
          telephone: contact.telephone ? contact.telephone : undefined,
          isPrincipale: contact.isPrincipale ? contact.isPrincipale : false,
          id: contact.id,
          idPatient: this.idPatient,
        }
      } else {
        this.listContact.objects.push({
          adresse: contact.adresse ? contact.adresse : undefined,
          complementAdresse: contact.complementAdresse ? contact.complementAdresse : undefined,
          codePostal: contact.codePostal ? contact.codePostal : undefined,
          ville: contact.ville ? contact.ville : undefined,
          email: contact.email ? contact.email : undefined,
          telephone: contact.telephone ? contact.telephone : undefined,
          isPrincipale: contact.isPrincipale ? contact.isPrincipale : false,
          idPatient: this.idPatient,
        })
      }
    }
    this.listContact.objects.sort((a: Adresse, b: Adresse) => {
      return a.isPrincipale ? 1 : (b.isPrincipale ? -1 : 0);
    });
    this.closeHistoContactModal(true);
  }

  closeHistoContactModal(send: boolean) {
    if (send) {
      for (let contact of this.deletedAdresses) {
        this.listContact.objects.push(contact);
      }
      this.closeEmitter.emit(this.listContact.objects);
    } else {
      if (this.isEdit) {
        for (let contact of this.deletedAdresses) {
          contact.disabled = false;
          this.listContact.objects.push(contact);
        }
        this.listContact.objects.sort((a: Adresse, b: Adresse) => {
          return a.isPrincipale ? 1 : (b.isPrincipale ? -1 : 0);
        });
      }
      this.closeEmitter.emit();
    }

  }

  public checkPhoneNumber(control: AbstractControl): { [key: string]: boolean } | null {
    const regexPhone = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/gmi;
    if (control.value !== undefined && control.value !== '' && !regexPhone.test(control.value)) {
      return { 'patternError': true };
    }
    return null;
  }

}
